<div class="main-view">
  <div class="container-user-card-vehicle">
    <!-- Vista previa de la tarjeta -->
    <div class="section-preview">
      <article
        class="card"
        [ngClass]="{
          'animate-scale': animateCard,
          'animate-scale-back': !animateCard
        }"
      >
        <header>
          <div class="titles_container">
            <p
              class="title"
              style="cursor: pointer; background-color: transparent"
            >
              {{ getDisplayValue() }}
            </p>

            <p
              *ngIf="config.showIMEI"
              class="title_secondary"
              style="cursor: pointer; background-color: transparent"
            >
              {{ vehicleData.imei }}
            </p>
          </div>

          <div class="dates_container">
            <i class="icon_header">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="#000"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                />
              </svg>
            </i>
            <time style="cursor: pointer; background-color: transparent">
              {{ vehicleData.date }}
            </time>
          </div>
        </header>

        <div class="location_container">
          <p *ngIf="config.showSIM" class="location">
            Número SIM: {{ vehicleData.sim }}
            <i class="icon_location">
              <svg
                class="icon"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 -960 960 960"
              >
                <path
                  d="M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z"
                />
              </svg>
            </i>
          </p>
        </div>

        <main class="card_content">
          <div class="tabs_section">
            <app-tabs-vehicle
              *ngIf="config.showColorStatus"
              variant="inMotion"
            ></app-tabs-vehicle>
            <app-label-vehicle
              *ngIf="config.showIgnitionStatus"
              [style.backgroundColor]="'#313131'"
              [style.color]="'#fff'"
              style="border-radius: 4px"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-power"
              >
                <path d="M12 2v10" />
                <path d="M18.4 6.6a9 9 0 1 1-12.77.04" />
              </svg>
            </app-label-vehicle>
            <app-label-vehicle
              *ngIf="config.showSpeed"
              [value]="40"
              [unitMeasurement]="'km/h'"
            >
              <i>
                <svg
                  _ngcontent-iaq-c224=""
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                >
                  <path
                    _ngcontent-iaq-c224=""
                    fill="currentColor"
                    d="M15.91 13.34l2.636-4.026-.454-.406-3.673 3.099c-.675-.138-1.402.068-1.894.618-.736.823-.665 2.088.159 2.824.824.736 2.088.665 2.824-.159.492-.55.615-1.295.402-1.95zm-3.91-10.646v-2.694h4v2.694c-1.439-.243-2.592-.238-4 0zm8.851 2.064l1.407-1.407 1.414 1.414-1.321 1.321c-.462-.484-.964-.927-1.5-1.328zm-18.851 4.242h8v2h-8v-2zm-2 4h8v2h-8v-2zm3 4h7v2h-7v-2zm21-3c0 5.523-4.477 10-10 10-2.79 0-5.3-1.155-7.111-3h3.28c1.138.631 2.439 1 3.831 1 4.411 0 8-3.589 8-8s-3.589-8-8-8c-1.392 0-2.693.369-3.831 1h-3.28c1.811-1.845 4.321-3 7.111-3 5.523 0 10 4.477 10 10z"
                  ></path>
                </svg>
              </i>
            </app-label-vehicle>
            <app-label-vehicle
              *ngIf="config.showBatteryVoltage"
              [value]="20"
              [unitMeasurement]="'V'"
            ></app-label-vehicle>
            <app-label-vehicle
              *ngIf="config.showFuel"
              [value]="10"
              [unitMeasurement]="'gal'"
            ></app-label-vehicle>
            <app-label-vehicle
              *ngIf="config.showElapsedTime"
              [value]="' ' + '2h 4m 53s'"
            >
              <!-- <i class="fas fa-hourglass-half"></i> -->
              <mat-icon size="12" variant="outlined">hourglass_empty</mat-icon>
            </app-label-vehicle>
            <app-label-vehicle
              *ngIf="config.showSatellites"
              [value]="2"
              [unitMeasurement]="'satélites'"
            >
              <i>
                <svg
                  width="12"
                  height="12"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    d="M233 7c-9.4-9.4-24.6-9.4-33.9 0l-96 96c-9.4 9.4-9.4 24.6 0 33.9l89.4 89.4-15.5 15.5C152.3 230.4 124.9 224 96 224c-31.7 0-61.5 7.7-87.8 21.2c-9 4.7-10.3 16.7-3.1 23.8L112.7 376.7 96.3 393.1c-2.6-.7-5.4-1.1-8.3-1.1c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32c0-2.9-.4-5.6-1.1-8.3l16.4-16.4L242.9 506.9c7.2 7.2 19.2 5.9 23.8-3.1C280.3 477.5 288 447.7 288 416c0-28.9-6.4-56.3-17.8-80.9l15.5-15.5L375 409c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9l-89.4-89.4 55-55c12.5-12.5 12.5-32.8 0-45.3l-48-48c-12.5-12.5-32.8-12.5-45.3 0l-55 55L233 7zm159 351l-72.4-72.4 62.1-62.1L454.1 296 392 358.1zM226.3 192.4L153.9 120 216 57.9l72.4 72.4-62.1 62.1z"
                  />
                </svg>
              </i>
            </app-label-vehicle>

            <ng-container *appHasPermission="'vehicles_options_teltonika'">
              <ng-container *ngIf="config.showTemperatureBLE">
                <app-label-vehicle
                  [value]="32 + ' °C'"
                  style="border-radius: 4px; color: #e53935"
                  backgroundColor="#fff"
                >
                  <i>
                    <svg width="16" height="16" fill="currentColor">
                      <use
                        xlink:href="./assets/icons/sprite.svg#thermometer-hot"
                      ></use>
                    </svg>
                  </i>
                </app-label-vehicle>
              </ng-container>
            </ng-container>

            <ng-container *appHasPermission="'vehicles_options_teltonika'">
              <ng-container *ngIf="config.showTemperatureEYE">
                <app-label-vehicle
                  [value]="8 + ' °C'"
                  style="border-radius: 4px; color: #00acc1"
                  backgroundColor="#fff"
                >
                  <i>
                    <svg width="16" height="16" fill="currentColor">
                      <use
                        xlink:href="./assets/icons/sprite.svg#thermometer-cold"
                      ></use>
                    </svg>
                  </i>
                </app-label-vehicle>
              </ng-container>
            </ng-container>

            <ng-container *appHasPermission="'vehicles_options_teltonika'">
              <ng-container *ngIf="config.showHumidityBLE">
                <app-label-vehicle
                  [value]="4 + ' %'"
                  style="border-radius: 4px; color: #29b6f6"
                  backgroundColor="#fff"
                >
                  <i>
                    <svg width="16" height="16" fill="currentColor">
                      <use
                        xlink:href="./assets/icons/sprite.svg#humidity-dry"
                      ></use>
                    </svg>
                  </i>
                </app-label-vehicle>
              </ng-container>
            </ng-container>

            <ng-container *appHasPermission="'vehicles_options_teltonika'">
              <ng-container *ngIf="config.showHumidityEYE">
                <app-label-vehicle
                  [value]="22 + ' %'"
                  style="border-radius: 4px; color: #43a047"
                  backgroundColor="#fff"
                >
                  <i>
                    <svg width="16" height="16" fill="currentColor">
                      <use
                        xlink:href="./assets/icons/sprite.svg#humidity-normal"
                      ></use>
                    </svg>
                  </i>
                </app-label-vehicle>
              </ng-container>
            </ng-container>
          </div>
        </main>

        <footer [ngStyle]="{ 'padding-bottom': '8px' }">
          <p *ngIf="config.showDriverName">
            {{ vehicleData.driverName }}
          </p>
        </footer>

        <div class="icon_open_close">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="m19.5 8.25-7.5 7.5-7.5-7.5"
            />
          </svg>
        </div>

        <div *ngIf="config.showVehicleIcon" class="image_container">
          <img
            src="./assets/images/vehicle/auto.png"
            class="image"
            width="32"
            height="32"
            decoding="async"
            loading="lazy"
          />
        </div>

        <ul class="card_actions">
          <li *ngIf="config.showHistoryButton">
            <button class="action_button">
              <span
                _ngcontent-ocn-c203=""
                class="btn-label"
                attr.aria-label="Recorrido hoy"
              >
                <!-- <svg width="16" height="16" fill="currentColor">
                  <use xlink:href="./assets/icons/sprite.svg#history"></use>
                </svg> -->
                <mat-icon size="18">history</mat-icon>
              </span>
            </button>
          </li>
          <li *ngIf="config.showCommandButton">
            <button class="action_button">
              <span
                _ngcontent-ocn-c203=""
                class="btn-label"
                attr.aria-label="Envio de comandos"
              >
                <!-- <svg width="16" height="16" fill="currentColor">
                  <use xlink:href="./assets/icons/sprite.svg#history"></use>
                </svg> -->
                <mat-icon size="18">history</mat-icon>
              </span>
            </button>
          </li>

          <li *ngIf="config.showDriverButton">
            <button class="action_button">
              <span _ngcontent-ocn-c203="" class="btn-label">
                <!-- <i
                  _ngcontent-ocn-c203=""
                  class="fas fa-male fa-lg"
                  style="color: inherit"
                ></i -->
                <mat-icon size="18" variant="outlined">man</mat-icon>
              </span>
            </button>
          </li>

          <li *ngIf="config.showNameButton">
            <button class="action_button">
              <span _ngcontent-opo-c201="" class="btn-label"
                ><svg
                  _ngcontent-opo-c201=""
                  version="1.0"
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24.000000 24.000000"
                  preserveAspectRatio="xMidYMid meet"
                >
                  <g
                    _ngcontent-opo-c201=""
                    transform="translate(0.000000,24.000000) scale(0.100000,-0.100000)"
                    fill="currentColor"
                    stroke="none"
                  >
                    <path
                      _ngcontent-opo-c201=""
                      d="M0 165 l0 -75 40 0 c38 0 40 -2 34 -24 -8 -35 4 -66 27 -66 10 0 19
            5 19 10 0 6 11 10 25 10 14 0 25 -4 25 -10 0 -5 9 -10 20 -10 22 0 36 36 25
            69 -5 15 -2 21 9 21 13 0 16 14 16 75 l0 75 -120 0 -120 0 0 -75z m177 58
            c-31 -2 -83 -2 -115 0 -31 2 -5 3 58 3 63 0 89 -1 57 -3z m53 -68 c0 -42 -3
            -55 -15 -55 -8 0 -15 5 -15 10 0 6 -7 10 -15 10 -8 0 -15 5 -15 10 0 6 -11 10
            -25 10 -14 0 -25 -4 -25 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -4 -15 -10 0 -5
            -18 -10 -40 -10 l-40 0 0 55 0 55 110 0 110 0 0 -55z m-73 -31 c-3 -3 -12 -4
            -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m41 -31 c3 -10 -12 -13 -52 -13 -51 0
            -66 7 -50 23 11 11 97 2 102 -10z m-5 -30 c-7 -2 -13 -11 -13 -19 0 -9 -12
            -14 -36 -14 -27 0 -35 4 -31 14 4 9 -1 17 -11 19 -9 3 10 5 43 5 33 0 54 -2
                48 -5z"
                    ></path>
                    <path
                      _ngcontent-opo-c201=""
                      d="M20 165 c0 -33 2 -35 35 -35 33 0 35 2 35 35 0 33 -2 35 -35 35 -33
            0 -35 -2 -35 -35z m60 10 c0 -7 -11 -12 -25 -12 -14 0 -25 5 -25 12 0 7 11 13
            25 13 14 0 25 -6 25 -13z m-7 -32 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19
            -2 13 -5z"
                    ></path>
                    <path
                      _ngcontent-opo-c201=""
                      d="M153 193 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"
                    ></path>
                    <path
                      _ngcontent-opo-c201=""
                      d="M138 173 c18 -2 45 -2 60 0 15 2 0 4 -33 4 -33 0 -45 -2 -27 -4z"
                    ></path>
                    <path
                      _ngcontent-opo-c201=""
                      d="M138 153 c18 -2 45 -2 60 0 15 2 0 4 -33 4 -33 0 -45 -2 -27 -4z"
                    ></path>
                    <path
                      _ngcontent-opo-c201=""
                      d="M33 113 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -17 0 -22 -2 -12 -5z"
                    ></path>
                  </g></svg
              ></span>
            </button>
          </li>

          <li *ngIf="config.showFollowButton">
            <button class="action_button">
              <svg
                _ngcontent-ldu-c198=""
                _ngcontent-opo-c203=""
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                style="color: inherit"
                fill="currentColor"
              >
                <path
                  _ngcontent-ldu-c198=""
                  _ngcontent-opo-c203=""
                  d="M9.5 10.287c0-.41-.336-.743-.75-.743s-.75.333-.75.743.336.743.75.743.75-.333.75-.743zm4.5.495c0-.137-.112-.248-.25-.248h-3.5c-.138 0-.25.111-.25.248s.112.248.25.248h3.5c.138-.001.25-.112.25-.248zm2-.495c0-.41-.336-.743-.75-.743s-.75.333-.75.743.336.743.75.743.75-.333.75-.743zm-8.649-3.219h-1.101c-.138 0-.25.111-.25.248v.253c0 .393.463.49.808.49l.543-.991zm9.659 1.569c-.435-.8-.866-1.597-1.342-2.382-.393-.649-.685-.96-1.375-1.083-.698-.124-1.341-.172-2.293-.172s-1.595.048-2.292.172c-.69.123-.982.433-1.375 1.083-.477.785-.907 1.582-1.343 2.382-.344.63-.49 1.194-.49 1.884 0 .653.21 1.195.5 1.89v1.094c0 .273.224.495.5.495h.75c.276 0 .5-.222.5-.495v-.495h6.5v.495c0 .273.224.495.5.495h.75c.276 0 .5-.222.5-.495v-1.094c.29-.695.5-1.237.5-1.89 0-.69-.146-1.254-.49-1.884zm-7.821-1.873c.335-.554.426-.569.695-.617.635-.113 1.228-.157 2.116-.157s1.481.044 2.116.156c.269.048.36.064.695.617.204.337.405.687.597 1.03-.728.11-2.01.266-3.408.266-1.524 0-2.759-.166-3.402-.275.19-.34.389-.686.591-1.02zm5.798 5.256h-5.974c-.836 0-1.513-.671-1.513-1.498 0-.813.253-1.199.592-1.821.52.101 1.984.348 3.908.348 1.74 0 3.28-.225 3.917-.333.332.609.583.995.583 1.805 0 .828-.677 1.499-1.513 1.499zm2.763-4.952c.138 0 .25.111.25.248v.253c0 .393-.463.49-.808.49l-.543-.99h1.101zm-5.75-7.068c-5.523 0-10 4.394-10 9.815 0 5.505 4.375 9.268 10 14.185 5.625-4.917 10-8.68 10-14.185 0-5.421-4.478-9.815-10-9.815zm0 18c-4.419 0-8-3.582-8-8s3.581-8 8-8c4.419 0 8 3.582 8 8s-3.581 8-8 8z"
                ></path>
              </svg>
            </button>
          </li>

          <li *ngIf="config.showVisualizationButton">
            <button class="action_button">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.75"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-eye"
              >
                <path
                  d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"
                />
                <circle cx="12" cy="12" r="3" />
              </svg>
            </button>
          </li>
        </ul>
      </article>

      <div class="header-config">
        <h2>Vista previa</h2>
      </div>

      <div *ngIf="messageResponse !== ''" class="message-info">
        <i class="icon_info">
          <svg width="16" height="16" fill="currentColor">
            <use xlink:href="./assets/icons/sprite.svg#info-circle"></use>
          </svg>
        </i>
        <p>
          {{ messageResponse }}
        </p>
      </div>

      <button
        class="reset-button"
        (click)="resetConfiguration()"
        title="Restaurar configuración por defecto"
      >
        <svg width="24" height="24" fill="currentColor">
          <use xlink:href="./assets/icons/sprite.svg#refresh"></use>
        </svg>
      </button>
    </div>

    <!-- Configuración de la tarjeta -->
    <div class="section-customize">
      <!-- Tabs -->
      <div class="tab-container">
        <button
          *ngFor="let tab of tabs"
          class="tab-button"
          [class.active]="activeTab === tab.id"
          (click)="activeTab = tab.id"
        >
          {{ tab.label }}
        </button>
      </div>

      <!-- Opciones de configuración en dos columnas -->
      <div class="config-grid">
        <div class="config-item">
          <input type="checkbox" id="showIMEI" [(ngModel)]="config.showIMEI" />
          <label for="showIMEI">Mostrar IMEI en la tarjeta</label>
        </div>

        <div class="config-item">
          <input type="checkbox" id="showSIM" [(ngModel)]="config.showSIM" />
          <label for="showSIM">Mostrar número SIM en la tarjeta</label>
        </div>

        <div class="config-item">
          <input
            type="checkbox"
            id="showColorStatus"
            [(ngModel)]="config.showColorStatus"
          />
          <label for="showColorStatus"
            >Mostrar estado de transmisión</label
          >
        </div>

        <div class="config-item">
          <input
            type="checkbox"
            id="showIgnitionStatus"
            [(ngModel)]="config.showIgnitionStatus"
          />
          <label for="showIgnitionStatus"
            >Mostrar estado de ignición en la tarjeta</label
          >
        </div>

        <div class="config-item">
          <input
            type="checkbox"
            id="showSpeed"
            [(ngModel)]="config.showSpeed"
          />
          <label for="showSpeed">Mostrar velocidad en la tarjeta</label>
        </div>

        <div class="config-item">
          <input
            type="checkbox"
            id="showBatteryVoltage"
            [(ngModel)]="config.showBatteryVoltage"
          />
          <label for="showBatteryVoltage"
            >Mostrar voltaje de batería en la tarjeta</label
          >
        </div>

        <div class="config-item">
          <input type="checkbox" id="showFuel" [(ngModel)]="config.showFuel" />
          <label for="showFuel">Mostrar combustible en la tarjeta</label>
        </div>

        <div class="config-item">
          <input
            type="checkbox"
            id="showElapsedTime"
            [(ngModel)]="config.showElapsedTime"
          />
          <label for="showElapsedTime"
            >Mostrar tiempo transcurrido en la tarjeta</label
          >
        </div>

        <div class="config-item">
          <input
            type="checkbox"
            id="showSatellites"
            [(ngModel)]="config.showSatellites"
          />
          <label for="showSatellites"
            >Mostrar cantidad de satélites en la tarjeta</label
          >
        </div>

        <div
          *appHasPermission="'vehicles_options_teltonika'"
          class="config-item"
        >
          <input
            type="checkbox"
            id="showTemperatureBLE"
            [(ngModel)]="config.showTemperatureBLE"
          />
          <label for="showTemperatureBLE"
            >Mostrar la temperatura BLE en la tarjeta</label
          >
        </div>

        <div
          *appHasPermission="'vehicles_options_teltonika'"
          class="config-item"
        >
          <input
            type="checkbox"
            id="showTemperatureEYE"
            [(ngModel)]="config.showTemperatureEYE"
          />
          <label for="showTemperatureEYE"
            >Mostrar la temperatura EYE en la tarjeta</label
          >
        </div>

        <div
          *appHasPermission="'vehicles_options_teltonika'"
          class="config-item"
        >
          <input
            type="checkbox"
            id="showHumidityBLE"
            [(ngModel)]="config.showHumidityBLE"
          />
          <label for="showHumidityBLE"
            >Mostrar la humedad BLE en la tarjeta</label
          >
        </div>

        <div
          *appHasPermission="'vehicles_options_teltonika'"
          class="config-item"
        >
          <input
            type="checkbox"
            id="showHumidityEYE"
            [(ngModel)]="config.showHumidityEYE"
          />
          <label for="showHumidityEYE"
            >Mostrar la humedad EYE en la tarjeta</label
          >
        </div>

        <div class="config-item">
          <input
            type="checkbox"
            id="showVehicleIcon"
            [(ngModel)]="config.showVehicleIcon"
          />
          <label for="showVehicleIcon">Mostrar ícono del vehículo</label>
        </div>

        <div class="config-item">
          <input
            type="checkbox"
            id="showDriverName"
            [(ngModel)]="config.showDriverName"
          />
          <label for="showDriverName">Mostrar nombre del conductor</label>
        </div>

        <!-- <div class="config-item">
          <input
            type="checkbox"
            id="showActionButtons"
            [(ngModel)]="config.showActionButtons"
          />
          <label for="showActionButtons"
            >Mostrar control de visualización de puntos de vehículos</label
          >
        </div> -->

        <div class="config-item">
          <input
            type="checkbox"
            id="showCommandButton"
            [(ngModel)]="config.showCommandButton"
          />
          <label for="showCommandButton">Mostrar botón de Comando</label>
        </div>
        <div class="config-item">
          <input
            type="checkbox"
            id="showHistoryButton"
            [(ngModel)]="config.showHistoryButton"
          />
          <label for="showHistoryButton">Mostrar botón de historial</label>
        </div>

        <div class="config-item">
          <input
            type="checkbox"
            id="showDriverButton"
            [(ngModel)]="config.showDriverButton"
          />
          <label for="showDriverButton">Mostrar botón de conductor</label>
        </div>

        <div class="config-item">
          <input
            type="checkbox"
            id="showNameButton"
            [(ngModel)]="config.showNameButton"
          />
          <label for="showNameButton">Mostrar botón de nombre</label>
        </div>

        <div class="config-item">
          <input
            type="checkbox"
            id="showFollowButton"
            [(ngModel)]="config.showFollowButton"
          />
          <label for="showFollowButton">Mostrar botón de seguir vehículo</label>
        </div>

        <div class="config-item">
          <input
            type="checkbox"
            id="showVisualizationButton"
            [(ngModel)]="config.showVisualizationButton"
          />
          <label for="showVisualizationButton"
            >Mostrar botón de visualización</label
          >
        </div>
      </div>
    </div>

    <!-- Botón de confirmación -->
    <button
      class="confirm-button"
      (click)="saveConfiguration()"
      title="Guardar configuración"
    >
      <svg width="24" height="24" fill="currentColor">
        <use xlink:href="./assets/icons/sprite.svg#check"></use>
      </svg>
    </button>
  </div>
</div>
